export default "__VITE_ASSET__D_MqtBXo__"